module.exports = __webpack_public_path__ + "static/media/5J1A6813_Small.3aa1024b.jpg";